import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {
  Button,
  Grid,
  Box,
  TextField,
  Typography,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { plan } from "../../redux/planSlice";
import Pricing from "../about/Pricing";
import { useDispatch, useSelector } from "react-redux";
import CuModel from "../../components/CuModel";
import { loadStripe } from "@stripe/stripe-js";
import Utils from "../../utils/Utils";
import PaypalPayment from "./PaypalPayment";
import { fetchActiveSubscription, setSubscription } from "../../redux/subscriptionSlice";
import { useSearchParams, useNavigate } from "react-router-dom";
import { checkAuth } from "../../redux/authSlice";

const { serverURL } = Utils;
const stripePromise = loadStripe(
  "pk_live_51JlgwJHSt3jEUJdlSUoiTgDrNIeyIdFvzLJMCWJ9uTPAkqzCDiVHz3jiawrdG7dMBty4OgUliJZEN5d9Vup4xTYB000Xnd5m6G"
);

const Plans = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.planSlice.plans);
  const profile = useSelector((state) => state.auth.profile);
  const subscription = useSelector((state) => state.subscription.subscription);
  const subscriptionLoader = useSelector((state) => state.subscription.loader);
  const subscriptionStatus = useSelector((state) => state.subscription.status);
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [planData, setPlanData] = useState([]);
  const [upSellplanData, setUpSellPlanData] = useState([]);
  const [selectedPlan, setselectedPlan] = useState({});
  const [upSellSelectedPlan, setUpSellselectedPlan] = useState({});
  const [showPromoCode, setShowPromoCode] = useState(true);
  const [promoCode, setPromoCode] = useState("");
  const [showUpSellPlanModel, setShowUpSellPlanModel] = useState(false);
  const [promoCodeError, setPromoCodeError] = useState(false);
  const [paymentModel, setPaymentModel] = useState(false);
  const [finalPlanSelected, setFinalPlanSelected] = useState({});
  const isDark = theme.palette.mode === "dark";
  const bankAccountDetails = t("bankAccount", { returnObjects: true });
  const bankAccountLines = Array.isArray(bankAccountDetails)
    ? bankAccountDetails
    : [];

  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams();
  const session_id = searchParams.get('session_id')
    useEffect(() => {
      if (session_id) {
        dispatch(checkAuth())
        navigate('/plans')
      }
    }, [session_id])


  useEffect(() => {
    (async () => {
      setSkeletonLoader(true);
      await dispatch(plan()).unwrap();
      setSkeletonLoader(false);
    })();
  }, []);

  useEffect(() => {
    // Track upgrade visit once per page load
    const trackUpgradeVisit = async () => {
      try {
        await fetch(`${serverURL}/user/track-upgrade-visit`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });
      } catch (error) {
        console.error("Failed to track upgrade visit:", error);
      }
    };
    trackUpgradeVisit();
  }, []);

  useEffect(() => {
    planDataCall_();
  }, [data]);

  useEffect(() => {
    if (profile && profile.planType !== undefined) {
      console.log("User planType:", profile.planType);
    }
  }, [profile]);

  useEffect(() => {
    (async () => {
      if (profile && profile._id) {
        try {
          const activeSubscription = await dispatch(fetchActiveSubscription(profile._id)).unwrap();
          if (activeSubscription) {
            console.log("Active subscription found:", activeSubscription);
            dispatch(setSubscription({ subscription: activeSubscription }));
          } else {
            console.log("No active subscription found for user:", profile._id);
          }
        } catch (error) {
          console.log("Error fetching active subscription", error);
        }
      }
    })();
  }, [dispatch, profile]);


  useEffect(() => {
    console.log("Subscription:", subscription);
  }, [subscription]);

  const planDataCall_ = () => {
    let notUpSellPlan = data.filter(
      (plan) => (!plan.upsell || plan.upsell === 0) && !plan.promoCode
    );
    let upSellPlan = data.filter(
      (plan) => plan.upsell === 1 && !plan.promoCode
    );
    setPlanData(notUpSellPlan);
    setUpSellPlanData(upSellPlan);

    // if no promo code plan available then hide promo code field
    let promoCodePlan = data.filter((plan) => plan.promoCode);
    console.log("Promo code plans:", promoCodePlan, data, notUpSellPlan, upSellPlan);
    if (promoCodePlan.length === 0) {
      console.log("No promo code plans available, hiding promo code field.");
      setShowPromoCode(false);
    } else {
      setShowPromoCode(true);
    }
  };

  const filterPromoCodeHandler = () => {
    setPromoCodeError(false);
    if (promoCode === "") {
      let notUpSellPlan = data.filter(
        (plan) => plan.upsell === 0 && !plan.promoCode
      );
      setPlanData(notUpSellPlan);
    } else {
      let filterPromoCodePlan = data.filter(
        (plan) => plan.promoCode === promoCode
      );
      setPlanData(filterPromoCodePlan);
      if (filterPromoCodePlan.length === 0) {
        setPromoCodeError(true);
      }
    }
  };

  useEffect(() => {
    if (promoCode === "") {
      let notUpSellPlan = data.filter(
        (plan) => plan.upsell === 0 && !plan.promoCode
      );
      setPlanData(notUpSellPlan);
    }
  }, [promoCode]);

  const selectPlanHandler = async (plan) => {
    console.log("Selected plan:", plan);
    setselectedPlan(plan);
    setUpSellselectedPlan({});
    if (!promoCode && upSellplanData.length > 0 &&
      // check if there is any plan available which is greater than selected plan
        upSellplanData.some((upSellPlan) => Number(upSellPlan.value) > Number(plan.value))
    ) {
      setShowUpSellPlanModel(true);
    } else {
      setFinalPlanSelected(plan);
      setPaymentModel(true);
    }
  };

  const skipPromoCodeHandler = () => {
    if (!promoCodeError) {
      setShowPromoCode(false);
    }
  };

  const addedPromoCodeHandler = (e) => {
    setPromoCodeError(false);
    const { value } = e.target;
    setPromoCode(value);
  };

  const showUpSellPlanModelHandler = () => {
    setShowUpSellPlanModel(false);
    setUpSellselectedPlan({});
    setselectedPlan({});
  };

  const selectUpSellPlanHandler = (upSellPlan) => {
    setUpSellselectedPlan(upSellPlan);
  };

  const upSellPlanSkipHandler = async () => {
    setFinalPlanSelected(selectedPlan);
    setPaymentModel(true);
    setShowUpSellPlanModel(false);
  };

  const upSellPlanNextHandler = async () => {
    setFinalPlanSelected(upSellSelectedPlan);
    setShowUpSellPlanModel(false);
    setPaymentModel(true);
  };

  const stripePayHandler = async () => {
    let plan_ = { ...finalPlanSelected };
    plan_.value = Math.round(finalPlanSelected.value * 100);
    const stripe = await stripePromise;
    const res = await fetch(`${serverURL}/plan/checkout-session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(plan_),
    });
    const { id } = await res.json();
    const { error } = await stripe.redirectToCheckout({ sessionId: id });
    if (error) {
      console.error("Error during redirect:", error);
    }
  };

  const hidePaymentModelHandler = () => {
    setPaymentModel(false);
    setFinalPlanSelected({});
    setselectedPlan({});
    setUpSellselectedPlan({});
  };

  const sortedPlanData = [...planData].sort(
    (a, b) => Number(a.value) - Number(b.value)
  );

  return (
    <Box sx={{ maxWidth: 800, margin: "40px auto", padding: 2 }}>
      {skeletonLoader ? (
        <Grid container display={"block"} m={5}>
          <Grid item xs={12} md={6}>
            <Grid container>
              <Grid item xs={7}>
                <Skeleton
                  animation="pulse"
                  variant="rounded"
                  width="100%"
                  height={60}
                />
              </Grid>
              <Grid item xs={4} ml={1}>
                <Skeleton
                  animation="pulse"
                  variant="rounded"
                  width="100%"
                  height={60}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} mt={5}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Skeleton animation="pulse" variant="text" width={80} />
                    </TableCell>
                    <TableCell>
                      <Skeleton animation="pulse" variant="text" width={60} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[1, 2, 3, 4].map((item) => (
                    <TableRow key={item}>
                      <TableCell>
                        <Skeleton
                          animation="pulse"
                          variant="rounded"
                          width="70%"
                          height={24}
                        />
                      </TableCell>
                      <TableCell>
                        <Skeleton
                          animation="pulse"
                          variant="rounded"
                          width="50%"
                          height={24}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      ) : (
            <Grid container display={"block"} m={5}>
              {subscriptionLoader ? (
              <div className="mb-8">
                <div
                style={{
                  background: "linear-gradient(90deg, #f3e7b3 0%, #f7d774 100%)",
                  border: "1px solid #e6c200",
                  borderRadius: "16px",
                  boxShadow: "0 4px 24px 0 rgba(212, 175, 55, 0.25)",
                  padding: "24px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "24px",
                }}
                >
                <span
                  style={{
                  color: "#bfa100",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  marginRight: "12px",
                  }}
                >
                  {t("loadingSubscriptionDetails")}
                </span>
                </div>
              </div>
              ) : subscription ? (
              <div className="mb-8">
                <div
                style={{
                  background: "linear-gradient(90deg, #ffe9b3 0%, #ffd700 100%)",
                  border: "2px solid #e6c200",
                  borderRadius: "20px",
                  boxShadow: "0 6px 32px 0 rgba(212, 175, 55, 0.35)",
                  padding: "32px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "24px",
                  position: "relative",
                  overflow: "hidden",
                }}
                >
                <span
                  style={{
                  color: "#bfa100",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  marginRight: "16px",
                  letterSpacing: "1px",
                  }}
                >
                  <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  style={{ marginRight: 12, verticalAlign: "middle" }}
                  >
                  <circle cx="16" cy="16" r="16" fill="#FFD700" />
                  <path
                    d="M16 7l2.09 6.26H24l-5.045 3.67L19.91 23 16 18.77 12.09 23l1.955-6.07L9 13.26h5.91z"
                    fill="#fff8e1"
                  />
                  </svg>
                </span>
                <span
                  style={{
                  color: "#bfa100",
                  fontWeight: 900,
                  fontSize: "1.5rem",
                  textTransform: "uppercase",
                  marginRight: "18px",
                  letterSpacing: "2px",
                  textShadow: "0 2px 8px #fffbe6, 0 1px 0 #e6c200",
                  }}
                >
                  {subscription.planId?.description || "-"}
                </span>
                <span
                  style={{
                  color: "#bfa100",
                  fontWeight: 600,
                  fontSize: "1rem",
                  marginLeft: "10px",
                  fontStyle: "italic",
                  }}
                >
                  {subscription.expiry &&
                    t("expiresAt", {
                      date: new Date(
                        subscription.expiry.$date || subscription.expiry
                      ).toLocaleDateString(),
                    })}
                </span>
                {subscription.promoCode && (
                  <span
                  style={{
                    color: "#bfa100",
                    fontWeight: 600,
                    fontSize: "1rem",
                    marginLeft: "10px",
                    background: "rgba(255, 215, 0, 0.15)",
                    borderRadius: "8px",
                    padding: "2px 10px",
                  }}
                  >
                  {t("promoLabel")} {subscription.promoCode}
                  </span>
                )}
                {subscription.status === 0 && (
                  <span
                  style={{
                    color: "#d32f2f",
                    fontWeight: 700,
                    fontSize: "1rem",
                    marginLeft: "10px",
                    textShadow: "0 1px 0 #fffbe6",
                  }}
                  >
                  {t("inactive")}
                  </span>
                )}
                </div>
              </div>
              ) : (
              <div className="mb-8">
                <div
                style={{
                  background: "linear-gradient(90deg, #fffbe6 0%, #ffe082 100%)",
                  border: "1px solid #ffe082",
                  borderRadius: "16px",
                  boxShadow: "0 2px 12px 0 rgba(212, 175, 55, 0.15)",
                  padding: "24px",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "24px",
                }}
                >
                <span
                  style={{
                  color: "#bfa100",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  marginRight: "12px",
                  }}
                >
                  {t("noActiveSubscriptionFound")}
                </span>
                </div>
              </div>
              )}
              {showPromoCode && (
              <Grid item xs={12} md={8}>
                <Grid container>
                <Grid item xs={5}>
                  <TextField
                  value={promoCode}
                  onChange={(e) => addedPromoCodeHandler(e)}
                  fullWidth
                  id="outlined-basic"
                  label={t("promoCode")}
                  variant="outlined"
                  />
                </Grid>
                <Grid item xs={3} ml={1}>
                  <Button
                  onClick={() => {
                      filterPromoCodeHandler();
                    }}
                    fullWidth
                    sx={{ height: "100%" }}
                    variant="contained"
                  >
                    {t("apply")}
                  </Button>
                </Grid>
                {/* <Grid item xs={3} ml={1}>
                  <Button
                    onClick={() => {
                      skipPromoCodeHandler();
                    }}
                    fullWidth
                    sx={{ height: "100%" }}
                    variant="contained"
                  >
                    {t("skip")}
                  </Button>
                </Grid> */}
                {promoCodeError && (
                  <Grid item xs={12} sx={{ mt: "10px" }}>
                    <Typography color={"red"}>
                      {t("promoCodeNotValid")}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} mt={5}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>{t("plan")}</TableCell>
                    {/* <TableCell sx={{ fontWeight: 700 }}>{t("duration")}</TableCell> */}
                    <TableCell sx={{ fontWeight: 700 }}>{t("price")}</TableCell>
                    {/* <TableCell sx={{ fontWeight: 700 }} align="right">
                      {t("action")}
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedPlanData.map((plan) => (
                    <TableRow
                      key={plan._id}
                      hover
                      onClick={() => {
                        selectPlanHandler(plan);
                      }}
                      sx={{
                        cursor: "pointer",
                        backgroundColor:
                          plan._id === selectedPlan._id
                            ? isDark
                              ? "rgba(241, 99, 99, 0.16)"
                              : "rgba(241, 99, 99, 0.08)"
                            : "inherit",
                      }}
                    >
                      <TableCell sx={{ fontWeight: 500 }}>{plan.description}</TableCell>
                      {/* <TableCell>
                        {plan.duration ? `${plan.duration} ${t("days")}` : "-"}
                      </TableCell> */}
                      <TableCell>
                        {plan.currencySymbol} {plan.value}
                      </TableCell>
                      {/* <TableCell align="right">
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            selectPlanHandler(plan);
                          }}
                          size="small"
                          variant="outlined"
                        >
                          {plan._id === selectedPlan._id
                            ? t("selected")
                            : t("select")}
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          <Grid container justifyContent={"center"} mt={3}>
            <Grid item xs={12}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isDark ? "rgba(255,255,255,0.12)" : theme.palette.grey[300],
                  backgroundColor: isDark ? "rgba(255,255,255,0.02)" : "#f7f4db",
                }}
              >
                <Typography variant="body2" sx={{ mb: 1.5 }}>
                  {t("paymentOptions")}
                </Typography>
                {bankAccountLines.map((line, index) => (
                  <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    {line}
                  </Typography>
                ))}
              </Paper>
            </Grid>
          </Grid>

          </Grid>
        </Grid>
      )}

      <Box sx={{ maxWidth: 800, margin: "40px auto", padding: 2 }}>
        <Pricing showActivePlans={false} />
      </Box>

      <CuModel
        onClose={() => showUpSellPlanModelHandler()}
        open={showUpSellPlanModel}
      >
        <Grid container sx={{ p: "20px" }} justifyContent={"center"}>
          <Grid item xs={12} mb={2}>
            <Typography variant="h6" fontWeight={700}>
              {t("upsellText")}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>{t("plan")}</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>{t("price")}</TableCell>
                    <TableCell sx={{ fontWeight: 700 }} align="right">
                      {t("action")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {upSellplanData.filter(
                    // filter out plans which are less than or equal to selected plan
                    (plan) =>
                      Number(plan.value) > Number(selectedPlan.value)
                  ).map((plan) => (
                    <TableRow
                      key={plan._id}
                      hover
                      onClick={() => {
                        selectUpSellPlanHandler(plan);
                      }}
                      sx={{
                        cursor: "pointer",
                        backgroundColor:
                          plan._id === upSellSelectedPlan._id
                            ? isDark
                              ? "rgba(241, 99, 99, 0.16)"
                              : "rgba(241, 99, 99, 0.08)"
                            : "inherit",
                      }}
                    >
                      <TableCell>{plan.description}</TableCell>
                      <TableCell>
                        {plan.currencySymbol} {plan.value}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            selectUpSellPlanHandler(plan);
                          }}
                          size="small"
                          variant="outlined"
                        >
                          {plan._id === upSellSelectedPlan._id
                            ? t("selected")
                            : t("select")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={7} mt={4} textAlign={"center"}>
            <Button
              disabled={
                Object.keys(upSellSelectedPlan).length === 0 ? true : false
              }
              onClick={() => upSellPlanNextHandler()}
              sx={{ marginRight: "10px" }}
              variant="contained"
            >
              {t("next")}
            </Button>
            {Object.keys(upSellSelectedPlan).length === 0 && (
              <Button
                onClick={() => upSellPlanSkipHandler()}
                variant="contained"
              >
                {t("skip")}
              </Button>
            )}
          </Grid>
        </Grid>
      </CuModel>
      <CuModel onClose={() => hidePaymentModelHandler()} open={paymentModel}>
        <Grid container p={"40px"} width={"500px"}>
          <Grid item xs={12} textAlign={"center"} mb={4}>
            <Typography variant="h6">{t("payNow")}</Typography>
          </Grid>

          <Grid item xs={12} mb={3}>
            <Paper
              sx={{
                p: 2.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: isDark
                  ? "rgba(255,255,255,0.12)"
                  : theme.palette.grey[200],
                background: isDark
                  ? "linear-gradient(135deg, rgba(83,58,253,0.18) 0%, rgba(30,30,30,0.92) 100%)"
                  : "linear-gradient(135deg, #f8fbff 0%, #f5f3ff 100%)",
                boxShadow: isDark
                  ? "0 8px 28px rgba(0,0,0,0.35)"
                  : "0 8px 24px rgba(83,58,253,0.10)",
              }}
            >
              <Typography
                variant="overline"
                sx={{
                  letterSpacing: 1,
                  color: isDark
                    ? "rgba(255,255,255,0.7)"
                    : theme.palette.text.secondary,
                }}
              >
                {t("selected")}
              </Typography>

              <Typography fontWeight={800} mb={1} sx={{ color: theme.palette.text.primary }}>
                {finalPlanSelected?.description || "-"}
              </Typography>

              <Box
                sx={{
                  mt: 1.5,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    px: 1.25,
                    py: 1,
                    borderRadius: 1.5,
                    backgroundColor: isDark
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(83,58,253,0.06)",
                  }}
                >
                  <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    {t("duration")}
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {finalPlanSelected?.duration || "-"} {t("days")}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    px: 1.25,
                    py: 1,
                    borderRadius: 1.5,
                    backgroundColor: isDark
                      ? "rgba(255,255,255,0.06)"
                      : "rgba(83,58,253,0.06)",
                  }}
                >
                  <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    {t("price")}
                  </Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {finalPlanSelected?.currencySymbol || ""} {finalPlanSelected?.value ?? "-"}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Box
                  sx={{
                    backgroundColor: "#533afd",
                    textAlign: "center",
                    padding: "6px",
                    borderRadius: "5px",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    stripePayHandler();
                  }}
                >
                  {t("stripe")}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box>
                  <PaypalPayment planData={finalPlanSelected} />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CuModel>
    </Box>
  );
};

export default Plans;
